import { Tabs } from '@tempmee/react';
import { Box } from '~/commonComponents';
import { OnsiteInterviewStatus, OnsiteInterviewStatusMapper } from '~/domain/PermanentJobs';

const TABS = [
  OnsiteInterviewStatus.ActionNeeded,
  OnsiteInterviewStatus.Open,
  OnsiteInterviewStatus.Scheduled,
  OnsiteInterviewStatus.Completed,
  OnsiteInterviewStatus.Cancelled,
];

interface IOnsiteInterviewStatusFilterPanelProps {
  counts: Record<OnsiteInterviewStatus, number> & { all: number };
  onChange(tab: OnsiteInterviewStatus | 'all'): void;
}

export const OnsiteInterviewStatusFilterPanel = ({
  counts,
  onChange,
}: IOnsiteInterviewStatusFilterPanelProps) => {
  return (
    <Tabs
      defaultValue="all"
      onValueChange={(value) => onChange(value === 'all' ? 'all' : (value as OnsiteInterviewStatus))}
      style={{ alignItems: 'flex-start' }}
    >
      <Tabs.List style={{ gap: 16 }}>
        <Tabs.Tab value="all" data-cy="onsite-interview-filter-tab-all">
          {`All Active${counts.all > 0 ? ` (${counts.all})` : ''}`}
        </Tabs.Tab>
        {TABS.map((it) => (
          <Tabs.Tab key={it} value={it} data-cy={`onsite-interview-filter-tab-${it}`}>
            <Box
              backgroundColor={OnsiteInterviewStatusMapper.getColor(it)}
              borderRadius="100%"
              height={10}
              width={10}
              style={{ display: 'inline-block', marginRight: 6 }}
            />
            {`${OnsiteInterviewStatusMapper.toHumanReadable(it)}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
};
